import { render } from "./detalleProducto.vue?vue&type=template&id=d7bc4f16"
import script from "./detalleProducto.vue?vue&type=script&lang=js"
export * from "./detalleProducto.vue?vue&type=script&lang=js"

import "./detalleProducto.vue?vue&type=style&index=0&id=d7bc4f16&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__